module.exports = __webpack_public_path__ + "media/categories/1056-6d67e4db.svg";